<template>
  <span class="agent-avatar">
    <LogoMark />
  </span>
</template>

<script setup lang="ts">
import { LogoMark } from '@tallo/design-system';
</script>

<style scoped lang="scss">
.agent-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 1.6875rem;
  height: 1.6875rem;
  border-radius: var(--t-border-radius-half-rounded);
  background: var(--t-color-neutral-white);
  border: 1px solid var(--t-color-border-secondary);
  font-size: 0.78125rem;
}
</style>
